import { Placement, StandardChip } from "../../../../../../shared/components/badges/StandardChip"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { BankAccountStatus } from "../SupplierAdminPOSTypes"

export function formatAcquirersStatusText(text: string) {
    let formattedText = text.replace(/_/g, " ").toLowerCase()
    return formattedText.charAt(0).toUpperCase() + formattedText.slice(1)
}

export function AcquirersStatusChip({ status, placement }: { status: string; placement: Placement }) {
    switch (status) {
        case BankAccountStatus.PENDING:
            return (
                <LocalizedStrict id="supplier-acquiring-bank-accounts-status-pending">
                    <StandardChip variant="yellow" placement={placement}>
                        Pending
                    </StandardChip>
                </LocalizedStrict>
            )
        case BankAccountStatus.VALID:
            return (
                <LocalizedStrict id="supplier-acquiring-bank-accounts-status-valid">
                    <StandardChip variant="success" placement={placement}>
                        Valid
                    </StandardChip>
                </LocalizedStrict>
            )
        case BankAccountStatus.INVALID:
            return (
                <LocalizedStrict id="supplier-acquiring-bank-accounts-status-invalid">
                    <StandardChip variant="red" placement={placement}>
                        Invalid
                    </StandardChip>
                </LocalizedStrict>
            )
        case BankAccountStatus.REJECTED:
            return (
                <LocalizedStrict id="supplier-acquiring-bank-accounts-status-rejected">
                    <StandardChip variant="red" placement={placement}>
                        Rejected
                    </StandardChip>
                </LocalizedStrict>
            )
        default:
            return (
                <StandardChip variant="yellow" placement={placement}>
                    {formatAcquirersStatusText(status)}
                </StandardChip>
            )
    }
}
